import { FIRESTORE_COLLECTIONS } from '../firebase';
import type { TonyteActivity } from '../types';

const getRawType = (activity: TonyteActivity) => String((activity as any).type || '').toLowerCase();
const getCollectionName = (activity: TonyteActivity) =>
  String((activity as any).collection || activity.sourceCollection || '').toLowerCase();

export const isPlanActivity = (activity: TonyteActivity) => {
  const type = getRawType(activity);
  const collectionName = getCollectionName(activity);
  return (
    type === 'plan' ||
    collectionName === FIRESTORE_COLLECTIONS.plans ||
    activity.entryType === 'community_plan'
  );
};

export const isEventActivity = (activity: TonyteActivity) => {
  if (isPlanActivity(activity)) return false;
  const type = getRawType(activity);
  const collectionName = getCollectionName(activity);
  return (
    type === 'event' ||
    collectionName === 'events' ||
    collectionName === 'officialevents' ||
    activity.entryType === 'official_event'
  );
};
